module.exports = __webpack_public_path__ + "static/media/CRV.e6ec6a8b.png";